import Progress from '@components/v2/ui/Progress/Progress';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import useWidth from '../../../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderSummaryTestIds } from '../../../../../../../utils/testIds/OrderSummary.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import useOrderSummaryIncomeStatus from '../hooks/useOrderSummaryIncomeStatus';
import OrderSummaryIncomeStatusTooltip from './OrderSummaryIncomeStatusTooltip';

interface OrderSummaryIncomeStatusProps {
  isReadOnlyView: boolean;
}

const OrderSummaryIncomeStatus = ({ isReadOnlyView }: OrderSummaryIncomeStatusProps) => {
  const { translate } = useTranslation();
  const { mobileWidth } = useWidth();
  const { incomeStatus, totalValue, settledPercent } = useOrderSummaryIncomeStatus({
    isReadOnlyView,
  });

  if (!incomeStatus) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip
        placement="top"
        TooltipContent={
          <OrderSummaryIncomeStatusTooltip incomeStatus={incomeStatus} totalValue={totalValue} />
        }
      >
        <Stack direction="row" sx={{ alignItems: 'center', columnGap: 0.5 }}>
          <Progress value={settledPercent} testId={OrderSummaryTestIds.INCOME_STATUS} />
          {!mobileWidth && (
            <Typography noWrap variant="body2" sx={{ color: 'inherit' }}>
              {translate(LangEnum.GLOBAL_ORDER_INCOME)}
            </Typography>
          )}
        </Stack>
      </Tooltip>
    </Box>
  );
};

export default OrderSummaryIncomeStatus;
